/** Event name declared on an SSE frame, including a Xano-wrapped `data: event:` line. */
export function declaredSseEventName(frame: string): string {
  for (const line of frame.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (trimmed.startsWith('event:')) {
      return trimmed.slice('event:'.length).trim();
    }
    if (trimmed.startsWith('data:')) {
      const payload = trimmed.slice('data:'.length).trimStart();
      if (payload.startsWith('event:')) {
        return payload.slice('event:'.length).trim();
      }
    }
  }
  return '';
}

export function isUnknownSseEvent(
  frame: string,
  isKnown: (name: string) => boolean
): boolean {
  const name = declaredSseEventName(frame);
  return Boolean(name) && !isKnown(name);
}
